import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { MICROSOFT_365_OAUTH_REDIRECT_URI } from '../../env'

import verify_jwt from '../../utils/verify_jwt'
import { showCredentialToast } from '../../utils/showToast'
import useLogin365Mutation from '../../features/login/hooks/useLogin365Mutation'
import useLogoutMutation from '../../features/login/hooks/useLogout'

function AuthCodeHandler() {
  const location = useLocation()
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.auth.data)
  const { login365Mutation } = useLogin365Mutation()
  const { logoutMutation } = useLogoutMutation()

  useEffect(() => {
    const handleAuthCode = async () => {
      const searchParams = new URLSearchParams(location.search)
      const code = searchParams.get('code')

      if (code) {
        login365Mutation.mutate({
          code: code,
          redirectUri: MICROSOFT_365_OAUTH_REDIRECT_URI,
        })
        return
      }

      // Frequent verify
      if (user) {
        const { accessToken, publicKey } = user
        try {
          const decodedToken = await verify_jwt({
            token: accessToken,
            publicKey,
          })
          if (!decodedToken) {
            showCredentialToast(
              'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại'
            )
            await new Promise((resolve) => setTimeout(resolve, 500))
            logoutMutation.mutate()

            return
          }
        } catch (error) {
          showCredentialToast('Lỗi xác thực, vui lòng đăng nhập lại')
          await new Promise((resolve) => setTimeout(resolve, 500))
          logoutMutation.mutate()
        }
      }
    }

    handleAuthCode()
  }, [location, dispatch, user])

  return null
}

export default AuthCodeHandler
